<template>
  <slot></slot>
</template>

<script setup>
import { onMounted, provide, ref, watch } from "vue";
import pako from "pako";

const props = defineProps({
  url: {
    type: String,
    required: true,
  },
});

const loading = ref(false);
const genderDisparityRows = ref([]);

provide("livingWageGapCalculationGenderDisparityRowsLoading", loading);
provide("livingWageGapCalculationGenderDisparityRows", genderDisparityRows);

async function loadGenderDisparityRows() {
  if (!props.url) {
    loading.value = false;
    genderDisparityRows.value = [];
    return;
  }

  loading.value = true;

  const response = await fetch(props.url);
  if (!response.ok) {
    genderDisparityRows.value = [];
    loading.value = false;
    return;
  }

  const buffer = await response.arrayBuffer();
  const jsonText = pako.ungzip(new Uint8Array(buffer), { to: "string" });
  const parsedRows = JSON.parse(jsonText);

  genderDisparityRows.value = Array.isArray(parsedRows) ? parsedRows : [];
  loading.value = false;
}

function handleLoadError(error) {
  loading.value = false;
  genderDisparityRows.value = [];

  console.error(
    "[LivingWageGapCalculationGenderDisparityRowsLoader] Failed to load data",
    error,
  );
}

onMounted(() => {
  loadGenderDisparityRows().catch(handleLoadError);
});

watch(
  () => props.url,
  () => {
    loadGenderDisparityRows().catch(handleLoadError);
  },
);
</script>
